import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";

import type { ButtonProps } from "@mui/material";

export function AddStopButton(props: ButtonProps) {
  return (
    <Button variant="contained" sx={{ ml: "auto" }} {...props}>
      <AddIcon />
      Add Stop
    </Button>
  );
}
